import { ACCEPT_INCOMING_CALL } from "../../CONSTANTS";

export default function acceptIncomingCall({
  callId,
  clientId,
  clientNotFound = false,
}) {
  return {
    type: ACCEPT_INCOMING_CALL,
    payload: {
      callId,
      clientId,
      clientNotFound,
    },
  };
}



// WEBPACK FOOTER //
// ./src/model/subsystems/clients/actions/calls/acceptIncomingCall.js